import type { ReactNode } from 'react';
import { faThumbTack } from '@awesome.me/kit-4a6bf60416/icons/classic/regular';

import { Icon } from '@/components/ui/icon';
import { PageType } from '@/types/page';
import { PageIcon, UnpublishedChangesIndicator } from './page-icon';

interface PageContentProps {
  pageType?: PageType;
  title: string;
  isPublished: boolean;
  hasUnpublishedChanges: boolean;
  isScheduled?: boolean;
  isScheduleMissed?: boolean;
  pinned?: boolean;
  children?: ReactNode;
}

export function PageContent({
  pageType,
  title,
  isPublished,
  hasUnpublishedChanges,
  isScheduled,
  isScheduleMissed,
  pinned,
  children,
}: PageContentProps) {
  const resolvedPageType = pageType ?? PageType.BLANK;

  return (
    <>
      <PageIcon
        pageType={resolvedPageType}
        isPublished={isPublished}
        isScheduled={isScheduled}
        isScheduleMissed={isScheduleMissed}
      />
      <div className="flex min-w-0 flex-1 items-center gap-1">
        <span className="truncate text-left">{title}</span>
        {pinned && <Icon icon={faThumbTack} className="shrink-0 text-primary text-xs" />}
        {isPublished && hasUnpublishedChanges && (
          <UnpublishedChangesIndicator className="shrink-0" />
        )}
      </div>
      {children}
    </>
  );
}
